import { CheckoutService } from 'services/checkout.service';
import { getShippingMethodIndex } from 'services/cartUtils';
import { ModalService } from 'services/modal.service';
import { ContinueButton } from 'components/continueButton/continueButton';
import { ShippingMethodForm } from 'components/shippingMethodForm/shippingMethodForm';

import template from './editShippingMethod.html';
import './editShippingMethod.scss';

export const EditShippingMethod = angular
    .module('checkout.components.editShippingMethod', [
        'ngMaterial',
        CheckoutService,
        ModalService,
        ContinueButton,
        ShippingMethodForm
    ]).service('editShippingMethodService', (modalService) => {
        return {
            open: ($event, useNewCarts = false, availableShippingMethods, previouslySelectedShippingMethod) => {
                return modalService.open({
                    $event,
                    cssClass: 'edit-shipping-method',
                    template: `
                        <edit-shipping-method
                            layout="column"
                            use-new-carts="useNewCarts"
                            available-shipping-methods="availableShippingMethods"
                            previously-selected-shipping-method="previouslySelectedShippingMethod">
                        </edit-shipping-method>
                    `,
                    data: { useNewCarts, availableShippingMethods, previouslySelectedShippingMethod }
                });
            }
        };
    }).component('editShippingMethod', {
        bindings: {
            useNewCarts: '<',
            availableShippingMethods: '<',
            previouslySelectedShippingMethod: '<'
        },
        template,
        controller: class EditShippingMethodController {
            constructor(
                checkoutService,
                $mdDialog
            ) {
                angular.extend(this, {
                    checkoutService,
                    $mdDialog
                });
            }

            $onInit() {
                if (this.previouslySelectedShippingMethod) {
                    this.selectedShippingMethodIndex =
                        getShippingMethodIndex(this.availableShippingMethods, this.previouslySelectedShippingMethod);
                }
            }

            save() {
                if (this.editShippingMethodForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.editShippingMethodForm);
                    return;
                }

                if (this.useNewCarts) {
                    this.$mdDialog.hide({
                        shippingMethod: this.availableShippingMethods[this.selectedShippingMethodIndex]
                    });
                    return;
                }

                this.isUpdatingCart = true;
                return this.checkoutService.applyShippingMethodToCart(this.selectedShippingMethodIndex)
                    .then((cart) => {
                        this.isUpdatingCart = false;
                        this.$mdDialog.hide(cart);
                    }).catch((err) => {
                        this.checkoutService.showErrorDialog(err);
                    });
            }

            cancel() {
                this.$mdDialog.cancel();
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/editShippingMethod/editShippingMethod.js